<template>
    <div class="mb-3 border-b border-dashed md:pb-5 md:pt-2">
        <slot name="custom" />
        <!-- 無百分比欄位 -->
        <div
            v-if="!hasPercent"
            class="md:flex"
        >
            <div class="mb-2.5 md:w-1/2 md:mr-4 md:mb-0">
                <Multiselect
                    v-model="item.bankNo"
                    class="select-base"
                    :options="bankList"
                    placeholder="投資標的公司/名稱"
                    :disabled="item.disabled"
                    label="bankName"
                    :can-deselect="false"
                    no-options-text="無投資標的選項"
                    no-results-text="查無此標的公司"
                    @change="$emit('setFundCodeAndOptions',index)"
                />
                <!-- :disabled="disabled" -->
                <div class="error-msg text-right md:-mb-4">
                    {{ item.errorMessage.bankNo }}
                </div>
            </div>
            <div class="flex md:w-1/2">
                <div class="flex-grow mr-2.5 md:mr-4">
                    <Multiselect
                        v-model="item.fundCode"
                        class="select-base"
                        placeholder="投資標的代號/名稱"
                        :options="item.bankNo===''||!item.bankNo?fundBankList:groupFundBankList[item.bankNo]"
                        label="label"
                        :can-clear="false"
                        :can-deselect="false"
                        :disabled="item.disabled"
                        searchable
                        no-options-text="無投資標的選項"
                        no-results-text="查無此標的代號"
                        @select="$emit('setBankValue',index)"
                    />
                    <!-- :disabled="disabled" -->
                    <div class="error-msg text-right md:-mb-4">
                        {{ item.errorMessage.fundCode }}
                    </div>
                </div>
                <button
                    class="w-10 h-10 xs:w-12 xs:h-12 flex justify-center items-center rounded ring-1 ring-gray-100"
                    :class="item.disabled?'bg-gray-75':'bg-white'"
                    :disabled="item.disabled||arrayLength === 1"
                    @click="item.disabled||arrayLength === 1?'':openPopup(index)"
                >
                    <SvgIcon
                        icon-name="delete_forever"
                        class=" w-6 h-6 xs:w-8 xs:h-8"
                        :class="item.disabled || arrayLength === 1?'text-gray-200':'text-gray-700'"
                    />
                </button>
            </div>
        </div>
        <!-- 有百分比欄位 -->
        <div
            v-else
            class="md:flex"
        >
            <div
                v-if="hasTitle"
                class="text-[0.9375rem] font-bold text-black my-2.5 md:mr-3"
            >
                {{ index+1 }}.
            </div>
            <div class="mb-2.5 md:mb-0 md:mr-3 md:w-2/5">
                <Multiselect
                    v-model="item.bankNo"
                    class="select-base can-close"
                    :options="bankList"
                    placeholder="投資標的公司名稱"
                    label="bankName"
                    :can-deselect="false"
                    searchable
                    no-options-text="無投資標的選項"
                    no-results-text="查無此標的公司"
                    @change="$emit('setFundCodeAndOptions',index)"
                />
                <div class="error-msg text-right md:-mb-4">
                    {{ item.errorMessage.bankNo }}
                </div>
            </div>
            <div class="mb-2.5 md:mb-0 md:mr-3 md:w-2/5">
                <Multiselect
                    v-model="item.fundCode"
                    class="select-base can-close"
                    :options="item.bankNo===''||!item.bankNo?fundBankList:groupFundBankList[item.bankNo]"
                    placeholder="投資標的代號/名稱"
                    label="label"
                    :can-deselect="false"
                    searchable
                    no-options-text="無投資標的選項"
                    no-results-text="查無此標的代號"
                    @select="$emit('setBankValue',index)"
                    @clear="$emit('resetPercent',index)"
                />
                <div class="error-msg text-right md:-mb-4">
                    {{ item.errorMessage.fundCode }}
                </div>
            </div>
            <div class="flex justify-between md:justify-start mb-2.5 md:mb-0 md:w-1/5 flex-shrink-0">
                <div class="w-1/2 md:w-auto">
                    <div class="flex items-center">
                        <input
                            v-model.trim="item.percent"
                            inputmode="numeric"
                            autocomplete="off"
                            :disabled="item.disabledPercent || !item.fundCode"
                            class="input-base pr-6"
                            maxlength="3"
                            @input="$emit('validatePercent',index)"
                        >
                        <SvgIcon
                            icon-name="percent"
                            class=" w-5 h-5 -ml-6"
                            :class="[item.disabledPercent?'text-gray-200':'text-gray-600']"
                        />
                    </div>
                    <p class="error-msg  text-right  md:-mb-4">
                        {{ item.errorMessage.percent }}
                    </p>
                </div>
                <button
                    class="w-11 h-11 xs:w-12 xs:h-12 flex justify-center items-center rounded ring-1 ring-gray-100 md:ml-3 flex-shrink-0"
                    :class="arrayLength===1?'bg-gray-75':'bg-white'"
                    :disabled="arrayLength===1"
                    @click="arrayLength===1?'':$emit('openPopup',index)"
                >
                    <SvgIcon
                        icon-name="delete_forever"
                        class=" w-6 h-6 xs:w-8 xs:h-8"
                        :class="arrayLength===1?'text-gray-200':'text-gray-700'"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { toRef } from 'vue';
import Multiselect from '@vueform/multiselect';

export default {
    components: {
        Multiselect,
    },
    props: {
        hasTitle: {
            type: Boolean,
            default: false,
        },
        arrayLength: {
            type: Number,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        fundBankList: {
            type: Array,
            required: true,
        },
        groupFundBankList: {
            type: Object,
            required: true,
        },
        bankList: {
            type: Array,
            required: true,
        },
        hasPercent: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['validatePercent', 'setFundCodeAndOptions', 'setBankValue', 'openPopup', 'resetPercent'],
    setup(props) {
        const item = toRef(props, 'data');
        return { item };
    },
};
</script>
<style lang="scss" scoped>
:deep(.can-close) .multiselect-single-label-text {
    @apply pr-4;
}
:deep(.multiselect-clear) {
    @apply pr-2;
}
</style>
